// Âm báo (Web Audio, không cần file). WebView/trình duyệt CHẶN phát âm trước khi người dùng tương
// tác -> phải MỞ KHOÁ AudioContext ở lần chạm/gõ ĐẦU TIÊN, nếu không âm do socket kích (tin nhắn,
// BUZZ) sẽ TỊT dù đã gọi resume() (resume ngoài cử chỉ người dùng không có tác dụng trên nhiều máy).
let ctx = null;
function getCtx() {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    return ctx;
  } catch {
    return null;
  }
}

// Mở khoá 1 lần ở cử chỉ đầu tiên (chạm/gõ/bấm) — sau đó mọi âm do socket kích đều kêu được.
if (typeof window !== 'undefined') {
  let unlocked = false;
  const evs = ['pointerdown', 'touchstart', 'keydown', 'click'];
  const unlock = () => {
    if (unlocked) return;
    unlocked = true;
    getCtx();
    evs.forEach((e) => window.removeEventListener(e, unlock));
  };
  evs.forEach((e) => window.addEventListener(e, unlock, { passive: true }));
}

// Âm báo tin nhắn — 2 nốt ngắn.
export function playMessageSound() {
  const c = getCtx();
  if (!c) return;
  try {
    const now = c.currentTime;
    const notes = [
      [880, 0],
      [1175, 0.12],
    ];
    notes.forEach(([freq, t]) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + t);
      gain.gain.exponentialRampToValueAtTime(0.25, now + t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + t + 0.18);
      osc.connect(gain).connect(c.destination);
      osc.start(now + t);
      osc.stop(now + t + 0.2);
    });
  } catch {
    /* bỏ qua */
  }
}

// Âm BUZZ! kiểu Yahoo — 2 hồi "bzzt bzzt" trầm, gằn (sawtooth) để giật mình chú ý.
export function playBuzzSound() {
  const c = getCtx();
  if (!c) return;
  try {
    const now = c.currentTime;
    [0, 0.22].forEach((t0) => {
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = 'sawtooth';
      osc.frequency.setValueAtTime(170, now + t0);
      osc.frequency.linearRampToValueAtTime(115, now + t0 + 0.16);
      gain.gain.setValueAtTime(0.0001, now + t0);
      gain.gain.exponentialRampToValueAtTime(0.35, now + t0 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + t0 + 0.17);
      osc.connect(gain).connect(c.destination);
      osc.start(now + t0);
      osc.stop(now + t0 + 0.19);
    });
  } catch {
    /* bỏ qua */
  }
}
